import { DefaultParams } from '@/api/bbsworld/default';
import { ClientAuth } from '@/classes/ClientAuth';
import { Device } from '@/classes/Device';
import { API_URL, API_VERSION } from '@/constants';
import { CONTENT_GROUP_TYPE, ContentGroup, ContentGroupDetail } from '@/types';
import { stringify } from 'qs';

export type GetContentGroupsParams = {
  type_in?: Array<CONTENT_GROUP_TYPE>;
  thumbnailType?: 'IMAGE' | 'LOTTIE';
} & DefaultParams;

export async function getContentGroups(params: GetContentGroupsParams): Promise<Array<ContentGroup>> {
  const response = await fetch(
    `${API_URL}/api/${API_VERSION}/content-groups?${stringify({
      deviceId: Device.uuid,
      ...params,
    })}`,
    {
      method: 'GET',
      headers: ClientAuth.headers,
      credentials: 'include',
    },
  );

  const data = await response.json();

  return data;
}

export type GetContentGroupParams = {
  id: number;
  contentType?: 'ALL' | 'VIDEO' | 'GAME';
  headerType?: 'default' | 'mobile';
} & DefaultParams;

export async function getContentGroup(params: GetContentGroupParams): Promise<ContentGroupDetail> {
  const { id, ...variables } = params;

  const response = await fetch(`${API_URL}/api/${API_VERSION}/content-groups/${id}?${stringify(variables)}`, {
    method: 'GET',
    headers: ClientAuth.headers,
    credentials: 'include',
  });

  const data = await response.json();

  return data;
}
